// extracted by mini-css-extract-plugin
module.exports =  {"psk":"_0d624b9a27--psk--FX8pW","phone":"_0d624b9a27--phone--Jiwy6"};